import * as API from "@/store/actions/axios-api-instance";

export default async function getConfig({commit}, product) {
    try {
        commit('SET_LOADING', true)
        const config = await API.getConfig()
        commit('SET_PRODUCT_CONFIG', {product, config})
        commit('SET_LOADING', false)
    } catch (e) {
        commit('SET_LOADING', false)
        commit('SET_ERROR', e.message)
        console.log(e)
        throw e
    }
}